import React, { useState } from "react";
import countries from "./countries.json"; // see below for contents

export default function CountrySelect({ onChange, didMakeSelection }) {
  const [query, setQuery] = useState(didMakeSelection.name || "");
  const [selectedACountry, setSelectedACountry] = useState(true);
  const [selected, setSelected] = useState("");
  const [showList, setShowList] = useState(false);

  const filtered = countries.filter((c) =>
    c.name.toLowerCase().includes(query.toLowerCase())
  );

  const handleSelect = (country) => {
    setSelected(country.name);
    setSelectedACountry(true);
    setQuery(country.name);
    setShowList(false);
    onChange?.(country);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", position: "relative", width: "100%", maxWidth: "300px" }}>

      <input
        id="country"
        type="text"
        value={query}
        placeholder="Start typing..."
        onChange={(e) => {
          setQuery(e.target.value);
          setShowList(true);
        }}
        className={"survey-option"+(selectedACountry ? " selected" : "")}
        onFocus={() => setShowList(false)}
        style={{
          width: "80%",
          alignSelf: "center",
          padding: "0.6rem 0.8rem",
          borderRadius: "8px",
          border: "1px solid #ccc",
          fontSize: "0.9rem",
        }}
      />

      {showList && filtered.length > 0 && (
        <ul
          style={{
            position: "absolute",
            zIndex: 10,
            background: "white",
            listStyle: "none",
            width: "100%",
            maxHeight: "200px",
            overflowY: "auto",
            marginTop: "0.25rem",
            padding: 0,
            borderRadius: "8px",
            border: "1px solid #ccc",
            boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
          }}
        >
          {filtered.slice(0, 10).map((country) => (
            <li
              key={country.code}
              onClick={() => handleSelect(country)}
              style={{
                padding: "0.5rem 0.75rem",
                cursor: "pointer",
                background:
                  selected === country.name ? "rgba(0,0,0,0.05)" : "white",
              }}
              onMouseDown={(e) => e.preventDefault()} // prevent blur on click
            >
              {country.flag} {country.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}